export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Pending"] = "pending";
    OrderStatus["Executed"] = "executed";
    OrderStatus["Expired"] = "expired";
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Refunding"] = "refunding";
    OrderStatus["Refunded"] = "refunded";
})(OrderStatus || (OrderStatus = {}));
//# sourceMappingURL=swap-order-status.js.map